import { TFunction } from "i18next"

import { TeamPlayer } from "@/types/player"

export const useGetInfoErrMsg = (
  key: keyof TeamPlayer,
  t: TFunction<"translation", undefined>,
  newPlayer?: TeamPlayer,
) => {
  if (!newPlayer) {
    return ""
  }
  switch (key) {
    case "nickname":
      if (newPlayer.nickname.length > 35) {
        return t("rules.max_len", { name: t("name"), max_len: 35 })
      } else {
        return t("rules.required")
      }
    case "uniformNumber":
      if (newPlayer.uniformNumber > 100) {
        return t("rules.max", { name: t("jersey"), max: 100 })
      } else if (newPlayer.uniformNumber < 0) {
        return t("rules.min", { name: t("jersey"), min: 0 })
      } else {
        return t("rules.required")
      }
    case "height":
      if (newPlayer.height < 0) {
        return t("rules.min", { name: t("height"), min: 0 })
      } else {
        return t("rules.required")
      }
    case "weight":
      if (newPlayer.weight < 0) {
        return t("rules.min", { name: t("weight"), min: 0 })
      } else {
        return t("rules.required")
      }
    default:
      return ""
  }
}
